import api from "../../../api";
import {OperationalContextId} from "platformed-client/types";
import {param, typedQuery} from "../../typing";

export const operationalContext = typedQuery(
  ["tprm", "operationalContext", param<OperationalContextId>("tprmOperationalContextId")],
  async operationalContextId => {
    return await api.tprm.operationalContexts.get(operationalContextId);
  },
);
